import type { AnalyticsClient } from '../types'

/** The safe default: returned whenever analytics is disabled or consent is not granted. */
export const noopAnalytics: AnalyticsClient = {
  identify() {},
  capture() {},
  pageview() {},
  isFeatureEnabled() { return undefined },
  captureException() {},
  reset() {},
}
